import { RootState } from '@/app/store';
import { camelizeNestedKeys } from '@cex/shared-modules';
import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

import { mainEmptySplitApi } from '@/features/main/mainApi';

export type Asset = {
  id: string;
  name: string;
  basic_symbol: string;
  basic_code: string;
  unit_name: string;
  unit_multiplier: number;
};

export type AssetsResponse = Asset[];

const assetsAdapter = createEntityAdapter<any>({});
const initialState = assetsAdapter.getInitialState();

export const assetsApi = mainEmptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssets: builder.query({
      query: () => '/api/v1/assets',
      providesTags: (result) =>
        result
          ? [...result.ids.map((id) => ({ type: 'Assets' as const, id })), { type: 'Assets', id: 'Asset' }]
          : [{ type: 'Assets', id: 'Asset' }],
      transformResponse: (res: AssetsResponse) => {
        const camelizedResponse = camelizeNestedKeys(res);
        return assetsAdapter.setAll(initialState, camelizedResponse);
      }
    })
  })
});

// Selectors
// Calling `someEndpoint.select(someArg)` generates a new selector that will return
// the query result object for a query with those parameters.
// To generate a selector for a specific query argument, call `select(theQueryArg)`.
// In this case, the users query has no params, so we don't pass anything to select()
// @ts-ignore
const selectAssetsResult = assetsApi.endpoints.getAssets.select();

export const selectAssetsData = createSelector(selectAssetsResult, (apiSlice) => apiSlice.data);

export const { selectAll: selectAllAssets, selectById: selectAssetById } = assetsAdapter.getSelectors(
  (state: RootState) => selectAssetsData(state) ?? initialState
);

export const { useGetAssetsQuery } = assetsApi;
